export const Hrseparator: React.FC = () => {
    return (
        <hr className="wp-block-separator has-text-color has-alpha-channel-opacity has-background is-style-wide"
            style={{ backgroundColor: '#ffffff24', color: '#ffffff24' }} />
    );
}